module.exports = __webpack_public_path__ + "static/media/finish.86552f23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/finish.svg
// module id = 350
// module chunks = 7